import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { state } from 'aws-cognito-redux-saga'

const safeLocalStorageGet = key => {
  try {
    return window && window.localStorage ? window.localStorage.getItem(key) : null
  } catch (error) {
    return null
  }
}

class PrivateRoute extends React.Component {
  static propTypes = {
    auth: PropTypes.object,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    path: PropTypes.string,
    dashboardOnly: PropTypes.bool
  }

  render() {
    const { auth, component: Component, path, dashboardOnly, ...rest } = this.props
    const isSignedIn = auth && auth.isSignedIn !== state.AUTH_FAIL
    const usLimited = String(safeLocalStorageGet('us_limited') || '0')
    const isCustomer = usLimited === '1'
    const isCustomerRoute = (path || '').startsWith('/customer')
    const isLocalDevHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    const isLocalDevMode = process.env.NODE_ENV === 'development'
    const disableCustomerRedirect = process.env.REACT_APP_SKIP_CUSTOMER_REDIRECT === 'true'
    const skipCustomerRedirect = isCustomer && (isLocalDevHost || isLocalDevMode) && (disableCustomerRedirect || process.env.REACT_APP_SKIP_CUSTOMER_REDIRECT === undefined)

    if (!isSignedIn) {
      return <Redirect to="/signin" />
    }

    if (dashboardOnly) {
      if (safeLocalStorageGet('customerClientId') !== '23') {
        return <Redirect to={isCustomer ? '/customer-orderentry' : '/customer'} />
      }
      if (auth.isSignedIn !== state.AUTH_SUCCESS) {
        return null
      }
    }

    if (isCustomer && !isCustomerRoute && !skipCustomerRedirect) {
      return <Redirect to="/customer" />
    }

    return <Route {...rest} path={path} render={props => <Component {...props} />} />
  }
}

export default PrivateRoute
